import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import CommunityPostsListComponent from './CommunityPostsListComponent';

import { clearPostsList, getPostsList } from '../actions';

import { getCommunityPostsQuery } from '../utils';

import { AVOID_STATUSES } from '../constants';

import * as commonSelectors from '../../Shared/selectors';
import * as communitySelectors from '../selectors';

import usePrevious from '../../../hooks/usePrevious';

const CommunityPostsListContainer = (props) => {
  const {
    communityId,
    onGetPostsList,
    postsList,
    nextPosts,
    isLoading,
    search,
    communityType,
    setCommunityType,
    clearPostsList,
  } = props;

  const queryParams = getCommunityPostsQuery(
    search,
    communityId,
    communityType,
    AVOID_STATUSES, // we don't want to show content with AVOID_STATUSES approvalStatus
  );

  const prevSearch = usePrevious(search);
  const onSearch = useCallback(
    debounce((queryParams) => onGetPostsList(queryParams), 800),
    [],
  );

  useEffect(() => () => clearPostsList(), []);

  useEffect(() => {
    if (!prevSearch && !search) return;
    onSearch(queryParams);
  }, [search]);

  useEffect(() => {
    onGetPostsList(queryParams);
  }, [communityId, communityType]);

  const loadNextPosts = (isClearPrev = false) => {
    if (!isClearPrev && !isEmpty(nextPosts)) {
      onGetPostsList({ ...queryParams, ...nextPosts }, false);
    } else if (isClearPrev) {
      onGetPostsList(queryParams);
    }
  };

  return (
    <CommunityPostsListComponent
      loadNextPosts={loadNextPosts}
      nextPosts={nextPosts}
      isLoading={isLoading}
      postsList={postsList}
      communityType={communityType}
      setCommunityType={setCommunityType}
    />
  );
};

CommunityPostsListContainer.defaultProps = {
  nextPosts: null,
  postsList: [],
};

CommunityPostsListContainer.propTypes = {
  communityId: PropTypes.number.isRequired,
  onGetPostsList: PropTypes.func.isRequired,
  postsList: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool.isRequired,
  communityType: PropTypes.string.isRequired,
  setCommunityType: PropTypes.func.isRequired,
  clearPostsList: PropTypes.func.isRequired,
  search: PropTypes.string,
  nextPosts: PropTypes.shape({
    limit: PropTypes.number,
    offset: PropTypes.number,
  }),
};

const mapStateToProps = (state) => {
  const posts = communitySelectors.getPostsList(state);
  const isLoading = commonSelectors.getIsLoading(state);
  return {
    postsList: posts?.results,
    nextPosts: posts?.next,
    isLoading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetPostsList: (queryParams, isClearPrev = true) =>
    getPostsList(dispatch, queryParams, { isClearPrev }),
  clearPostsList: () => clearPostsList(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityPostsListContainer);
